// Initialize Task Nomenclatures Button
// Button to initialize all task nomenclatures with default data

import React, { useState } from 'react';
import { taskNomenclatureService } from '../../../services/taskNomenclatureService';

const InitializeTaskNomenclaturesButton = ({ userId }) => {
  const [initializing, setInitializing] = useState(false);

  const handleInitialize = async () => {
    const confirmed = window.confirm(
      'This will initialize all task nomenclatures with default data. ' +
      'If data already exists, it will be skipped. Continue?'
    );

    if (!confirmed) return;

    try {
      setInitializing(true);
      await taskNomenclatureService.initializeAllDefaults(userId);
      alert('Task nomenclatures initialized successfully!');
      window.location.reload(); // Refresh to show new data
    } catch (error) {
      console.error('Error initializing nomenclatures:', error);
      alert(`Error: ${error.message}`);
    } finally {
      setInitializing(false);
    }
  };

  return (
    <button
      onClick={handleInitialize}
      disabled={initializing}
      style={{
        background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
        color: 'white',
        border: 'none',
        padding: '8px 16px',
        borderRadius: '4px',
        fontSize: '0.875rem',
        fontWeight: '500',
        cursor: initializing ? 'not-allowed' : 'pointer',
        opacity: initializing ? 0.6 : 1
      }}
    >
      {initializing ? 'Initializing...' : 'Initialize Default Data'}
    </button>
  );
};

export default InitializeTaskNomenclaturesButton;


